// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"623":"d6b58428","917":"d6b58428","925":"d6b58428","964":"d6b58428"}[chunkId] + ".chunk.css";
};